<template>
  <div class="notree-boxbgcolor config">
    <ListPageLayout :loading="tableLoading">
    <template #filter>
        <div></div>
            <el-page-header
              style="padding:20px 0 0 20px;box-sizing: border-box;"
              @back="goBack"
              content="提现用户"
            >
            </el-page-header>
            <div class="searchbox">
              <form action="#" method="get" class="form-inline form-float">
                <div class="form-group"></div>
                <div class="form-group others">
                  <!-- <span class="search_btn">
                      <button
                        @click="searchList"
                        type="button"
                        class="btn btn-primary"
                        id="search_btn" :disabled="tableLoading">{{ tableLoading ? "查询中..." : "查询" }}</button>
                    </span> -->

                  <span class="add_btn">
                    <button
                      type="button"
                      class="btn btn-default"
                      id="add"
                      @click="addOrEdit()"
                    >
                      添加
                    </button>
                  </span>
                </div>
              </form>
            </div>
    </template>

      <el-table
              ref="table"
              border
              :data="tableListData"
              height="100%"
              :header-cell-style="tableHeaderStyle"
              :cell-style="styleObj"
            >
              <el-table-column
                show-overflow-tooltip
                label="收款方真实姓名"
                prop="userName"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="手机号"
                prop="mobile"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="小程序用户ID"
                prop="userId"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="小程序用户openId"
                prop="openid"
              ></el-table-column>

              <el-table-column show-overflow-tooltip label="操作">
                <template slot-scope="scope">
                  <button
                    class="edit operate-button"
                    type="button"
                    @click="addOrEdit(scope.row)"
                  >
                    修改
                  </button>
                  <!-- <button
                    class="delete operate-button"
                    type="button"
                    @click="del(scope.row.id)"
                  >
                    删除
                  </button> -->
                </template>
              </el-table-column>
            </el-table>

      <template #pagination>
        <Page v-on:pagination="receivePaginationData"></Page>
      </template>
    </ListPageLayout>
    <!-- 添加/修改 -->
        <el-dialog
          :lock-scroll="false"
          :close-on-click-modal="false"
          title="添加/修改提现用户"
          :visible.sync="dialogFormVisible"
          width="700px"
          @close="closeFormDialog"
          class="dialog-form"
        >
          <div class="clearfix">
            <el-form
              @submit.native.prevent
              class="fl"
              style="width:100%;"
              ref="form"
              label-position="right"
              :model="form"
              :label-width="formLabelWidth"
              id="form"
            >
              <el-form-item
                label="手机号"
                prop="mobile"
                style="vertical-align: middle;"
              >
                <el-col :span="16">
                  <el-input v-model="form.mobile"></el-input>
                </el-col>
                <i
                  style="margin-left:10px;font-size:20px;color:#999;cursor: pointer;"
                  class="el-icon-search"
                  @click="onUserInfoSearch"
                ></i>
              </el-form-item>
              <el-form-item label="小程序用户Id" prop="userId">
                <el-col :span="18">
                  <el-input v-model="form.userId" readonly></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="小程序用户openId" prop="openid">
                <el-col :span="18">
                  <el-input v-model="form.openid" readonly></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="收款方真实姓名" prop="userName">
                <el-col :span="18">
                  <el-input v-model="form.userName"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
            <el-button @click="dialogFormVisible = false">取 消</el-button>
          </div>
        </el-dialog>
  </div>
</template>
<script>
import { withdrawUser, shareUserInfo } from "@/api/url";
import { TYPE } from "./constant";
import { mapState, mapMutations } from "vuex";
import Page from "@/page/commons/page";
import ListPageLayout from '@/page/commons/ListPageLayout.vue';
export default {
  data() {
    return {
      tableLoading: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      form: {
        userId: "",
        openid: "",
        mobile: "",
        userName: "",
      },
      configureForm: {
        groupId: "",
        code: [],
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        sharedId: [],
      },
      tableListData: [],
      tableListDataTitle: [],
      groupBaseConfigureData: [],
      groupConfigureData: [], //用户配置数据
      tableListDataExcel: {},
      formLabelWidth: "180px",
      dialogFormVisible: false,
      dialogFormHeartTimeVisible: false,
      dialogConfigureVisible: false, //配置
      parks: [],
      shareUser: {},
      ruleId: "",
    };
  },
  components: {
    ListPageLayout,
    Page,
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function(curPage) {
      var _this = this;
      this.tableLoading = true;
      this.$get(`${withdrawUser()}`, {
        page: curPage,
        limit: this.search.pageSize,
        ruleId: this.ruleId,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = (data?.data?.rows ?? []).map((item) => {
          return item;
        });
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    openDialog: function() {},
    closeFormDialog: function() {
      this.$refs["form"].resetFields();
    },
    searchList: function() {
      if (this.tableLoading) return;
      this.tableList();
    },
    clearSearch: function() {
      if (this.tableLoading) return;
      this.search.pageNumber = 1;
      this.tableList();
    },
    addOrEdit: function(row) {
      this.dialogFormVisible = true;
      this.form = {
        userId: "",
        openid: "",
        mobile: "",
        userName: "",
      };
      if (Boolean(row?.id)) {
        this.form = {
          ...row,
        };
      }
    },
    addOrEditTrue: function() {
      var _this = this;
      this.$refs["form"].validate(function(valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          if (!Boolean(_this.form?.id)) {
            _this
              .$postRequest(withdrawUser(), {
                ..._this.form,
                ruleId: _this.ruleId,
              })
              .then((data) => {
                if (data?.status != 200)
                  return _this.$message.success(data.message);
                _this.$notify({
                  type: "success",
                  message: "添加成功",
                  title: "成功",
                });
                _this.search.pageNumber = 1;
                _this.tableList(1);
              });
          } else {
            _this
              .$putRequest(withdrawUser(), {
                ..._this.form,
              })
              .then((data) => {
                if (data?.status != 200)
                  return _this.$message.success(data.message);
                _this.$notify({
                  type: "success",
                  message: "修改成功",
                  title: "成功",
                });
                _this.tableList(_this.curIndex);
              });
          }
        }
      });
    },

    getShareUserInfo(mobile) {
      this.$get(shareUserInfo(), { mobile }).then((res) => {
        if (res?.status !== 200) {
          this.$message.error(res?.message || '获取用户信息失败');
          return;
        }
        this.form.userId = res?.data?.[0]?.value ?? "";
        console.log("user id=>", this.form.userId);
        this.form.openid = res?.data?.[0]?.openId ?? "";
      }).catch((error) => {
        console.error(error);
      });
    },
    onUserInfoSearch() {
      this.getShareUserInfo(this.form.mobile);
    },
    handleType(row) {
      return TYPE[row.type];
    },

    handleSwitchChange(e, row) {
      this.$putRequest(withdrawUser(), {
        ...row,
        enabled: e ? 1 : 2,
      }).then((res) => {
        if (res.status != 200) return this.$message.error(res.message);
        this.$message.success("设置成功");
        this.tableList(this.curIndex);
      });
    },
    handleRemove() {},
    handlePictureCardPreview() {},
    goBack() {
      this.$router.go(-1);
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  created: function() {},
  mounted: function() {
    this.ruleId = this.$route.query.id;
    this.search.pageNumber = 1;
    this.tableList(1);
  },
  destroyed: function() {},
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;

  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
/* .edit,
    .delete,
    .chargingRules {
      display: inline-block;
      width: 40px;
      height: 20px;
      background: #278cd8;
      color: white;
      margin-right: 4px;
      font-size: 12px;
      line-height: 20px;
      border-radius: 4px;
    } */
.chargingRules {
  width: 60px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.fail,
.success,
.someSuccess {
  display: inline-block;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}
.fail {
  background: red;
  color: red;
}
.success {
  background: green;
  color: green;
}
.someSuccess {
  background: #ff6100;
  width: 65px;
  height: 20px;
  line-height: 20px;
  color: white;
  font-size: 12px;
}
.lowerEquip {
  width: 60px;
  font-size: 12px;
  background: #409eff;
  color: white;
  height: 20px;
  line-height: 20px;
}
.refresh {
  display: inline-block !important;
}
.pow {
  text-align: left !important;
  padding-left: 1% !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  margin-left: -5%;
  border-radius: 1px;
}
.configure-message {
  margin-right: 20px;
}
</style>
<style>
.config .el-form-item {
  margin: 0;
}
.config .dialog-form .el-divider {
  margin: 0;
  margin-bottom: 10px;
}
.config .dialog-form .el-select {
  width: 100%;
}
.config .el-popper.el-cascader__dropdown {
  z-index: 20000 !important;
}
.config .el-cascader {
  position: relative;
}
</style>
